module.exports = __webpack_public_path__ + "img/tempctrl_on.e976194f.png";